angular.module('autoremind.directives')
    .directive('imageList', ['$timeout', '$parse', '$compile', 'templateService',
    function ($timeout, $parse, $compile, templateService) {
        return {
            restrict: 'A',
            scope: {
                ngModel: '=',
                imageList: '='
            },
            multiElement: true,
            priority: 2,
            link: function (scope, element, attr, ngModel) {
                if (angular.isDefined(attr.imageUpload)) {
                    element.removeAttr('image-list');
                    return;
                }
                scope.element = element;
                if (scope.ngModel === '') {
                    var imgKey = attr.ngModel.replace("template.", "");
                    if (angular.isDefined(templateService.previewModel.inFile[imgKey])) {
                        scope.element.attr('src', templateService.previewModel.inFile[imgKey]);
                    }
                }
                scope.$watch('ngModel', function (newVal, oldVal) {
                    if (newVal === '' || newVal === oldVal) {
                        return;
                    }
                    scope.element.attr('src', newVal);
                });
                scope.images = [];
                scope.$watch('imageList', function (newVal, oldVal) {
                    var tmpImagesStr = '[]';
                    if (typeof scope.imageList === 'string' && scope.imageList.length > 2) {
                        tmpImagesStr = angular.copy(scope.imageList);
                    }
                    try {
                        scope.images = JSON.parse(tmpImagesStr);
                    }
                    catch (err) {
                    }
                    if (!angular.isObject(scope.images)) {
                        scope.images = [];
                    }
                });
                var directiveHtml = "<div class='imageList' ng-mouseenter='hover = true' ng-mouseleave='hover = false'><div class='imageNav' ng-if='hover'>" +
                    "<div ng-click='leftImg()' >" +
                    "<span class='glyphicon glyphicon-chevron-left' aria-hidden='true'></span>" +
                    "</div>" +
                    "<div ng-click='rightImg()'>" +
                    "<span class='glyphicon glyphicon-chevron-right' aria-hidden='true'></span>" +
                    "</div>" +
                    "</div>" +
                    "</div>";
                scope.add = function () {
                    element.removeAttr('image-list');
                    var parent = element.parent();
                    parent.append('<div class="imageContainer"></div>');
                    var imageContainer = parent.find('.imageContainer');
                    imageContainer.append(element);
                    imageContainer.append(directiveHtml);
                    $compile(imageContainer)(scope);
                    $compile(element)(scope);
                }();
                scope.hover = false;
                var imgIndex = 0;
                for (var i in scope.images) {
                    if (attr.src === scope.images[i]) {
                        imgIndex = i;
                        break;
                    }
                }
                function updateModel() {
                    if (!scope.images[imgIndex] || scope.images[imgIndex] === '') {
                        return;
                    }
                    scope.ngModel = scope.images[imgIndex];
                    // scope.element.attr('src', scope.images[imgIndex])
                }
                scope.leftImg = function () {
                    imgIndex--;
                    if (imgIndex < 0) {
                        imgIndex = scope.images.length - 1;
                    }
                    updateModel();
                };
                scope.rightImg = function () {
                    imgIndex++;
                    if (imgIndex >= scope.images.length) {
                        imgIndex = 0;
                    }
                    updateModel();
                };
            }
        };
    }]);
//# sourceMappingURL=image-list.directive.js.map